/* ==========================================================================
   BELORA — SKIMS PURE · image arrival
   An image marked .sk-fade starts transparent (only while this script runs:
   html.sk-js) and is shown once it has decoded; its blurred placeholder
   (.sk-blur, snippets/sk-blur.liquid) then fades out. Covers images that are
   already cached, lazy ones that load on scroll, and images inserted later by
   a section re-render (cart drawer, rails, recommendations).
   ========================================================================== */
(function () {
  'use strict';
  if (window.__skMedia) return;
  window.__skMedia = true;

  function reveal(img) {
    if (img.classList.contains('is-in')) return;
    img.classList.add('is-in');
    var box = img.parentElement;
    if (box) {
      Array.prototype.forEach.call(box.querySelectorAll(':scope > .sk-blur'), function (b) { b.classList.add('is-gone'); });
      /* Stops the skeleton pulse. The reference pulses a #e8e5df block in the card's media frame
         while the photo is in flight (div[data-testid=skeleton].bg-gray-darker.animate-pulse,
         pulse 2s cubic-bezier(.4,0,.6,1) infinite — tmp-sk-pulsewhere, 12 Sep). A class is used
         rather than :has() so the rule does not depend on selector support. */
      box.classList.add('is-loaded');
    }
  }
  function settle(img) {
    if (img.complete && img.naturalWidth > 0) {
      if (img.decode) img.decode().then(function () { reveal(img); }, function () { reveal(img); });
      else reveal(img);
    }
  }
  function sweep(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('img.sk-fade:not(.is-in)'), settle);
  }

  // load / error do not bubble, but they can be caught on the way down
  document.addEventListener('load', function (e) { var t = e.target; if (t && t.classList && t.classList.contains('sk-fade')) reveal(t); }, true);
  document.addEventListener('error', function (e) { var t = e.target; if (t && t.classList && t.classList.contains('sk-fade')) reveal(t); }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { sweep(); });
  else sweep();
  window.addEventListener('load', function () { sweep(); });

  // images put in later (section re-renders, recommendations, the bag)
  if ('MutationObserver' in window) {
    var pending = false;
    new MutationObserver(function () {
      if (pending) return; pending = true;
      window.requestAnimationFrame(function () { pending = false; sweep(); });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
